const LANDING_PROD_ORIGIN = 'https://bebecare.pages.dev';
const LANDING_LOCAL_ORIGIN = 'http://localhost:8080';

export function resolveInviteUrl(inviteUrl: string): string {
  const trimmed = inviteUrl.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  if (typeof window === 'undefined') {
    return `${LANDING_PROD_ORIGIN}${path}`;
  }

  const { hostname } = window.location;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

  return `${isLocalHost ? LANDING_LOCAL_ORIGIN : LANDING_PROD_ORIGIN}${path}`;
}
